/* Peak Labs - live stock sync.
   The homepage catalogue (window.SHOPIFY_CATALOGUE) is rendered server-side with
   Shopify availability baked in, but Shopify's full-page cache can serve a stale
   render. This script re-checks each product's live availability via Shopify's
   /products/<handle>.js endpoint (which is not full-page cached) and patches the
   in-memory catalogue, then asks the React app to repaint. Result: an in-stock or
   out-of-stock flip in Shopify shows on the live site without waiting for a publish.
   Plain JS, no build step. Safe no-op in local preview (needs SHOPIFY_CATALOGUE). */
(function () {
  if (!(window.SHOPIFY_CATALOGUE && window.SHOPIFY_CATALOGUE.length)) return; // production only

  function repaintSoon() {
    clearTimeout(repaintSoon._t);
    repaintSoon._t = setTimeout(function () {
      if (typeof window.__peakStockRepaint === "function") window.__peakStockRepaint();
    }, 150);
  }

  function syncOne(p) {
    if (!p || !p.id) return;
    fetch("/products/" + encodeURIComponent(p.id) + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        var changed = false;
        var avail = !!d.available;
        if (p.available !== avail) { p.available = avail; changed = true; }
        var label = avail ? "In Stock · UAE" : "Out of Stock";
        if (p.stock !== label) { p.stock = label; changed = true; }
        if (Array.isArray(p.variants) && d.variants) {
          p.variants.forEach(function (v) {
            var match = d.variants.filter(function (dv) { return String(dv.id) === String(v.variantId); })[0];
            if (match && v.available !== !!match.available) { v.available = !!match.available; changed = true; }
          });
        }
        if (changed) repaintSoon();
      })
      .catch(function () { /* offline or endpoint blocked - keep server-rendered value */ });
  }

  function run() { window.SHOPIFY_CATALOGUE.forEach(syncOne); }

  // Wait until the React app has published window.CATALOGUE (compiled via Babel).
  var tries = 0;
  var iv = setInterval(function () {
    if (window.CATALOGUE && window.CATALOGUE.length) { clearInterval(iv); run(); }
    else if (++tries > 120) clearInterval(iv);
  }, 80);
})();
